module.exports = __webpack_public_path__ + "img/ic_temp.267dd754.svg";